import './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { initMixpanel } from '~/analytics';

import App from './App';

initMixpanel();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
